import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";

const InputDate = ({ type, name, label, value, onChange, minDate, maxDate, required, error }) => {
  const { t } = useTranslation();

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      {label && <label htmlFor={name}>{t(label)}</label>}
      {required && <span>{t("REQUIRED_FIELD")}</span>}
      <input type={"date"} name={name} min={minDate} max={maxDate} value={value} onChange={(e) => onChange(e, name)} />
    </div>
  );
};

export default InputDate;
